import { useRef, useState } from "react";
import Cart from "../components/cart";
import CategoryFilter from "../components/categoryFilter";
import DatePicker from "../components/datepicker.js";
import Delivery from "../components/delivery";
import FloatingCart from "../components/floatingCart";
import OrderingLayout, { OrderReceipt } from "../components/orderingLayout";
import ProductList from "../components/productList";
import { Scrollable } from "../components/styles";

function Frontpage() {
  const [categories, setCategories] = useState([]);
  const cartRef = useRef(null);

  return (
    <OrderingLayout
      header={<DatePicker />}
      receipt={
        <OrderReceipt
          id="menu-cart"
          targetRef={cartRef}
          delivery={<Delivery />}
          flatOnMobile
        >
          <Cart />
        </OrderReceipt>
      }
    >
      <div className="category-zone">
        <Scrollable>
          <CategoryFilter setFilteredCategories={setCategories} />
        </Scrollable>
      </div>
      <div className="product-zone">
        <ProductList categories={categories} />
      </div>
      <FloatingCart targetRef={cartRef} />
    </OrderingLayout>
  );
}

export default Frontpage;
